import { combineReducers } from 'redux';
import type { SynchronyStateType } from '../support/synchrony-support/reducer.ts';
import synchrony from '../support/synchrony-support/reducer.ts';
import type { ViewState } from './views/index.ts';
import views from './views/index.ts';

export type RootState = {
	fabricEditor: {
		views: ViewState;
		synchrony: SynchronyStateType;
	};
	entities: any;
	router: any;
	views: {
		viewPage: {
			labels: any;
		};
	};
};

export default combineReducers({
	synchrony,
	views,
});
